import type { LucideProps } from "lucide-react";

import { LandmarkIcon, LockKeyholeIcon, NotebookTextIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

const options = [
	{
		title: "Connect your bank Account",
		Icon: LandmarkIcon,
		description:
			"Connect bank account to easily fund your wallet and make easy payment"
	},
	{
		title: "Setup a security pin",
		Icon: LockKeyholeIcon,
		description: "Set up a security pin to authorise your payments"
	},
	{
		title: "Complete your KYC",
		Icon: NotebookTextIcon,
		description: "Complete your KYC, let's get to know you more"
	}
];

export const Route = createFileRoute("/get-started")({
	component: GetStartedPage
});

function GetStartedPage() {
	const navigate = useNavigate();
	return (
		<section className="relative grid h-screen grid-rows-3 flex-col place-items-center bg-primary text-background">
			<div className="h-fit text-center">
				<h1 className="text-2xl">Get started</h1>
				<p>Get the most out of Intasida by completing these few steps</p>
				<Button
					onClick={() => navigate({ to: "/buyer/home" })}
					variant="ghost"
					className="absolute right-20 top-20 border"
				>
					Skip
				</Button>
			</div>
			<div className="flex max-w-xl flex-col items-center justify-center space-y-4">
				{options.map(option => (
					<GetStartedCard key={option.title} {...option} />
				))}
			</div>
		</section>
	);
}
function GetStartedCard({
	title,
	Icon,
	description
}: {
	title: string;
	Icon: React.ComponentType<LucideProps>;
	description: string;
}) {
	return (
		<div className="flex w-full cursor-pointer items-center justify-start rounded-xl border bg-hover p-4">
			<div className="grid size-14 place-items-center">
				<Icon />
			</div>
			<div className="p-4">
				<h2 className="text-start text-lg font-semibold">{title}</h2>
				<p className="font-in text-sm text-primary-foreground/10">
					{description}
				</p>
			</div>
		</div>
	);
}
